<template>
  <v-card>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-5 pa-4">
          <v-card-title>
            <span class="headline">Purchase Return #{{ details.return_number }}</span>
          </v-card-title>
          <v-card-subtitle>
            <div>
              <strong>Return Date:</strong> {{ details.return_date }}<br>
              <strong>Related Invoice:</strong> {{ details.invoice_number || '-' }}<br>
              <strong>Reason:</strong> {{ details.reason_for_return || '-' }}<br>
              <strong>Sub Total:</strong> {{ currencyCode }}{{ formatNumber(details.sub_total) }}<br>
              <strong>Tax Amount:</strong> {{ currencyCode }}{{ formatNumber(details.tax_amount) }}<br>
              <strong>Discount Amount:</strong> {{ currencyCode }}{{ formatNumber(details.discount_amount) }}<br>
              <strong>Grand Total:</strong> {{ currencyCode }}{{ formatNumber(details.grand_total) }}<br>
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-data-table
      v-if="items.length > 0"
      :headers="itemHeaders"
      :items="items"
      dense
      item-key="id"
    >
      <template v-slot:item="{ item, index }">
        <tr :class="[index % 2 === 0 ? 'dark-row' : 'light-row', 'custom-row']">
          <td>{{ item.product_code }}</td>
          <td>{{ item.product_name || '-' }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ currencyCode }}{{ formatNumber(item.unit_price) }}</td>
          <td>{{ currencyCode }}{{ formatNumber(item.total_price) }}</td>
          <td>{{ item.condition }}</td>
          <td>{{ item.reason || '-' }}</td>
        </tr>
      </template>
    </v-data-table>

    <v-alert v-if="!loading && items.length === 0" type="info" class="mt-5" outlined>
      No items found for this return.
    </v-alert>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { CustomerService } from "@/services/customer-service.js";

export default {
  name: "CustomerReturnDetails",
  data() {
    return {
      details: {},
      items: [],
      loading: false,
      itemHeaders: [
        { text: "Product Code", value: "product_code" },
        { text: "Product Name", value: "product_name" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit Price", value: "unit_price" },
        { text: "Total Price", value: "total_price" },
        { text: "Condition", value: "condition" },
        { text: "Reason", value: "reason" },
      ],
    };
  },
  computed: {
    ...mapSettingsGetters(["currencyCode"]),
  },
  created() {
    this.fetchDetails();
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async fetchDetails() {
      this.loading = true;
      try {
        const res = await CustomerService.getCustomerReturnInfo(this.$route.params.returnUuid);
        this.details = res.data.data || {};
        this.items = this.details.items || [];
      } catch (e) {
        this.details = {};
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dark-row { background-color: #f4f4f4; }
.light-row { background-color: #ffffff; }
.custom-row:hover { background-color: #e8e8e8; cursor: pointer; }
</style>
